"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePolicyHardCopyDto = exports.UpdatePolicyHardCopyDocumentDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const create_policy_hard_copy_dto_1 = require("./create-policy-hard-copy.dto");
class UpdatePolicyHardCopyDocumentDto {
}
exports.UpdatePolicyHardCopyDocumentDto = UpdatePolicyHardCopyDocumentDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Id",
        example: 237,
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], UpdatePolicyHardCopyDocumentDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document Type ID",
        example: 237,
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", Number)
], UpdatePolicyHardCopyDocumentDto.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document ID",
        example: 25,
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", Number)
], UpdatePolicyHardCopyDocumentDto.prototype, "documentId", void 0);
class UpdatePolicyHardCopyDto {
}
exports.UpdatePolicyHardCopyDto = UpdatePolicyHardCopyDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 789,
        description: "Opportunity Activity ID",
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], UpdatePolicyHardCopyDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 403,
        description: "Status ID",
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], UpdatePolicyHardCopyDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_policy_hard_copy_dto_1.InsurerPolicyHardCopyDetailsDto),
    tslib_1.__metadata("design:type", typeof (_a = typeof create_policy_hard_copy_dto_1.InsurerPolicyHardCopyDetailsDto !== "undefined" && create_policy_hard_copy_dto_1.InsurerPolicyHardCopyDetailsDto) === "function" ? _a : Object)
], UpdatePolicyHardCopyDto.prototype, "insurerPolicyHardCopyDetails", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_policy_hard_copy_dto_1.DeviationSectionDto),
    tslib_1.__metadata("design:type", typeof (_b = typeof create_policy_hard_copy_dto_1.DeviationSectionDto !== "undefined" && create_policy_hard_copy_dto_1.DeviationSectionDto) === "function" ? _b : Object)
], UpdatePolicyHardCopyDto.prototype, "deviationSection", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_policy_hard_copy_dto_1.DeviationsAddressedSectionDto),
    tslib_1.__metadata("design:type", typeof (_c = typeof create_policy_hard_copy_dto_1.DeviationsAddressedSectionDto !== "undefined" && create_policy_hard_copy_dto_1.DeviationsAddressedSectionDto) === "function" ? _c : Object)
], UpdatePolicyHardCopyDto.prototype, "deviationsAddressedSection", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: [UpdatePolicyHardCopyDocumentDto],
        description: "Array of documents",
        required: true,
    }),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => UpdatePolicyHardCopyDocumentDto),
    tslib_1.__metadata("design:type", Array)
], UpdatePolicyHardCopyDto.prototype, "documents", void 0);
